<template>
  <div class="World3D">

   <!-- defaultEnvironmentFloorTexture: #groundTex;  -->
   <!-- tap-place -->

    <a-scene 
    landing-page
    xrextras-loading
    xrextras-runtime-error
    renderer="colorManagement:true"
    recenter="recenterDistance: 3; recenterHeight: 1; recenterFactor: 0.25"
    xrweb="
      allowedDevices: any;
      defaultEnvironmentFogIntensity: 0.5; 
      defaultEnvironmentFloorColor: #FFF;
      defaultEnvironmentSkyBottomColor: #B4C4CC; 
      defaultEnvironmentSkyTopColor: #5ac8fa;
      defaultEnvironmentSkyGradientStrength: 0.5;">

      <a-assets>
        <!-- <img id="groundTex" src="https://world-bank-prototype.dpt.media/static/sand.jpg"> -->
      </a-assets>

      <a-camera
        id="camera"
        position="0 8 0"
        raycaster="objects: .cantap"
        cursor="
          fuse: false;
          rayOrigin: mouse;">
      </a-camera>

      <a-entity
        light="
          type: directional;
          intensity: 0.8;
          castShadow: true;
          shadowMapHeight:2048;
          shadowMapWidth:2048;
          shadowCameraTop: 40;
          shadowCameraBottom: -40;
          shadowCameraRight: 40;
          shadowCameraLeft: -40;
          target: #camera"
        xrextras-attach="target: camera; offset: 8 15 4"
        position="1 4.3 2.5"
        shadow>
      </a-entity>
      <a-light type="ambient" intensity="0.5"></a-light>
      <a-box
        id="ground"
        class="cantap"
        scale="1000 2 1000"
        position="0 -0.99 0"
        material="shader: shadow; transparent: true; opacity: 0.4"
        shadow>
      </a-box>
     <!--  <a-plane
        position="0 5 0"
        rotation="0 0 0"
        width="4"
        height="4"
        transparent ="false"
        draw></a-plane> -->


      <a-box id="box" position="0 .5 0" rotation="0 45 0" scale="1 1 1"></a-box>


      <!-- <a-sky color="#ECECEC"></a-sky> -->

    </a-scene>
    <canvas id="source-canvas" width="256" height="256"></canvas>

    <div class="World3D__txt">{{ msg }}</div>

    <!-- 
    <a-scene
      tap-place
      landing-page
      xrextras-loading
      xrextras-runtime-error
      renderer="colorManagement:true"
      xrweb="
        allowedDevices: any;
        defaultEnvironmentFogIntensity: 0.5; 
        defaultEnvironmentFloorTexture: #groundTex; 
        defaultEnvironmentFloorColor: #FFF;
        defaultEnvironmentSkyBottomColor: #B4C4CC; 
        defaultEnvironmentSkyTopColor: #5ac8fa;
        defaultEnvironmentSkyGradientStrength: 0.5;">
      
      <a-assets>
        <img id="groundTex" src="https://world-bank-prototype.dpt.media/static/sand.jpg">
        <a-asset-item id="cactusModel" src="https://world-bank-prototype.dpt.media/static/cactus.glb"></a-asset-item>
      </a-assets>

      <a-camera
        id="camera"
        position="0 8 0"
        raycaster="objects: .cantap"
        cursor="
          fuse: false;
          rayOrigin: mouse;">
      </a-camera>

      <a-entity
        light="
          type: directional;
          intensity: 0.8;
          castShadow: true;
          shadowMapHeight:2048;
          shadowMapWidth:2048;
          shadowCameraTop: 40;
          shadowCameraBottom: -40;
          shadowCameraRight: 40;
          shadowCameraLeft: -40;
          target: #camera"
        xrextras-attach="target: camera; offset: 8 15 4"
        position="1 4.3 2.5"
        shadow>
      </a-entity>

      <a-light type="ambient" intensity="0.5"></a-light>
      <a-box
        id="ground"
        class="cantap"
        scale="1000 2 1000"
        position="0 -0.99 0"
        material="shader: shadow; transparent: true; opacity: 0.4"
        shadow>
      </a-box>
    </a-scene> 
    -->

  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'World3D',
  render: h => h(), 
  data: ()=>({
    msg: 'msg'
  }),

  beforeCreate() {

    const _that = this

    AFRAME.registerComponent("recenter", {

      schema: {
        // 0 means don't auto recenter, ex. 10 means auto recenter after moving 10 units
        recenterDistance: {default: 0},
        // 0 means don't adjust height, ex. 5 means recenter to height of 5
        recenterHeight: {default: 0},
        // 0 means when adjusting height, go all the way, ex. .75 means go .75 of the way
        recenterFactor: {default: 0},

      },

      init() {

        this.delta = 0
        this.count = 0

        this.px = 0
        this.py = 0
        this.pz = 0
  
        this.locked = null
        this.camera = document.getElementById('camera')

        // this.output = document.getElementById('recenterOut')

        // document.getElementById('recenter').addEventListener('click', () => this.recenter())
        // document.getElementById('recenterSmart').addEventListener('click', () => this.smartRecenter())

        this.origin = this.camera.object3D.position.clone()
        this.recenterSum = this.data.recenterDistance * 1.4

        const ground = document.getElementById('ground')
              ground.addEventListener('click', (event) => { 

          console.log('xxxxxxx '+ event.detail.intersection.distance);
          const touchPoint = event.detail.intersection.point
          
          // console.log(touchPoint)
          // console.log(this.el)

          const box = document.getElementById('box')
                box.setAttribute('position', touchPoint)

          this.locked = touchPoint
          this.updateTxt(touchPoint)

        })

      },

      tick() {

        // console.log(this.delta);
   
        // if (this.data.recenterDistance > 0 && this.delta == 0) {

        if (this.delta == 0 && this.locked) {

          // console.log('tick');

          // If auto recentering, use cheap distance calculation to decide whether or not to recenter

          const moveX = (this.origin.x - this.camera.object3D.position.x)
          const moveZ = (this.origin.z - this.camera.object3D.position.z)
          const moveY = (this.origin.y - this.camera.object3D.position.y)

          // if (moveX > this.data.recenterDistance ||
          //   moveZ > this.data.recenterDistance ||
          //   moveX + moveZ > this.recenterSum) {

          this.px -= moveX
          this.py -= moveY
          this.pz -= moveZ

          this.origin.copy(this.camera.object3D.position)

          //     if (this.data.recenterHeight) {
          //       // Recenter with current x,z position, but adjust height to prevent scale drift
          //       if (this.data.recenterFactor) {
          //         // Reset origin with weighted average to desired height
          //         this.origin.y = this.data.recenterFactor * this.data.recenterHeight +
          //           (1 - this.data.recenterFactor) * this.origin.y
          //       } else {
          //         this.origin.y = this.data.recenterHeight
          //       }
          //     }

              // console.log(moveX);
              // console.log(moveZ);
              // console.log('xxxxxxxxxxxx');

              // this.el.sceneEl.emit( 'recenter', {
              //   origin: this.origin, 
              //   facing: this.camera.object3D.quaternion
              // })

              // const newElement = document.createElement('a-entity')
              //       newElement.setAttribute('position', { 
              //         x: this.locked.x + this.px,
              //         y: this.locked.y + this.py, 
              //         z: this.locked.z + this.pz
              //       })
              //       newElement.setAttribute('geometry', {
              //         primitive: 'box',
              //         height: 1,
              //         width: 1
              //       })

              // this.el.sceneEl.appendChild(newElement)

              this.count += 1
              this.updateTxt(this.locked.x + this.px)
 
              // this.onRecenter(this.origin)

          // }
        }

        this.delta += 1
        if(this.delta == 2)
          this.delta = 0
      },

      updateTxt: (txt)=> {
        this.updateTxt(txt)
      },

      // onRecenter: (origin)=> {
      //   this.updateTxt(origin)
      // },

    })

    // AFRAME.registerComponent("draw", {

    //   schema: {
    //     min: {default: 6},
    //     max: {default: 10},
    //   },

    //   init() {

    //     this.isDrawing = false
    //     this.texture = null
        
    //     let canvas = document.getElementById("source-canvas")
    //         canvas.addEventListener("mouseup", e => { this.isDrawing = false })
    //         canvas.addEventListener("touchend", e => { this.isDrawing = false })
    //         canvas.addEventListener("mousedown", e => { this.isDrawing = true })
    //         canvas.addEventListener("touchstart", e => { this.isDrawing = true })

    //     this.el.addEventListener("loaded", e => {

    //       this.texture = new THREE.CanvasTexture(canvas)

    //       let mesh = this.el.getObject3D("mesh")
    //       let textureToBeRemoved = mesh.material.map
    //       mesh.material.map = this.texture
    //       if (textureToBeRemoved) textureToBeRemoved.dispose()

    //       this.el.setAttribute('position', { x:0, y:0, z:-30 })
    //       this.el.setAttribute('scale', '5 5 5')

    //       // console.log(this.texture)

    //     })

    //     const ground = document.getElementById('ground')
    //           ground.addEventListener('click', (event) => { 

    //       console.log(event.detail.intersection.point);
    //       console.log('xxxxxxx '+ event.detail.intersection.distance);
    //       const touchPoint = event.detail.intersection.point
          
    //       // console.log(touchPoint)
    //       // console.log(this.el)

    //       this.el.setAttribute('position', touchPoint)
    //       this.el.setAttribute('scale', '5 5 5')

    //     })
    //   },

    //   tick() {
    //     // console.log('xxxx '+ this.texture)
    //     if (this.texture && this.isDrawing) this.texture.needsUpdate = true;
    //   }

    // })


    // AFRAME.registerComponent('tap-place', {
    //   schema: {
    //     min: {default: 6},
    //     max: {default: 10},
    //   },
    //   init() {
    //     const ground = document.getElementById('ground')
    //           ground.addEventListener('click', (event) => {

    //             const newElement = document.createElement('a-entity')
    //             const touchPoint = event.detail.intersection.point
    //                   newElement.setAttribute('position', touchPoint)
    //             const randomYRotation = Math.random() * 360
    //                   newElement.setAttribute('rotation', `0 ${randomYRotation} 0`)
    //             const randomScale = Math.floor(Math.random() * (Math.floor(this.data.max) - Math.ceil(this.data.min)) + Math.ceil(this.data.min))

    //                   newElement.setAttribute('visible', 'false')
    //                   newElement.setAttribute('scale', '0.0001 0.0001 0.0001')
    //                   newElement.setAttribute('shadow', {
    //                     receive: false,
    //                   })

    //                   newElement.setAttribute('gltf-model', '#cactusModel')
    //             this.el.sceneEl.appendChild(newElement)
    //             newElement.addEventListener('model-loaded', () => {            
    //             newElement.setAttribute('visible', 'true')
    //             newElement.setAttribute('animation', {
    //               property: 'scale',
    //               to: `${randomScale} ${randomScale} ${randomScale}`,
    //               easing: 'easeOutElastic',
    //               dur: 800,
    //             })
    //           })
    //     })
    //   },
    //   tick(){
    //     // console.log('x');
    //     // if (this.texture && this.isDrawing) this.texture.needsUpdate = true;
    //   }
    // })

  },

  mounted() {
    this.$nextTick(()=>{
      this.init()
    })
  },

  methods: {

    updateTxt(txt) {
      this.msg = String(txt)
    },

    init() {

      // const c = document.getElementById("source-canvas")
      // const ctx = c.getContext("2d")
      // const grd = ctx.createRadialGradient(75, 50, 5, 90, 60, 100)
      //       grd.addColorStop(0, "red")
      //       grd.addColorStop(1, "white")

      // ctx.fillStyle = grd
      // ctx.fillRect(0, 0, 256, 256)

      /* BASED ON http://www.williammalone.com/articles/create-html5-canvas-javascript-drawing-app/ */
      
      const canvas = document.getElementById('source-canvas')
      const context = canvas.getContext('2d')
      let clickX = new Array()
      let clickY = new Array()
      let clickDrag = new Array()
      let paint = false

      canvas.addEventListener('touchstart', function(e) {
        const mouseX = e.pageX - this.offsetLeft
        const mouseY = e.pageY - this.offsetTop
          
        paint = true
        addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop)
        redraw()
      })

      canvas.addEventListener('mousedown', function(e) {

        const mouseX = e.pageX - this.offsetLeft
        const mouseY = e.pageY - this.offsetTop
          
        paint = true
        addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop)
        redraw()
      })

      // canvas.addEventListener('mousemove', function(e) {
      //   if(paint){
      //     addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop, true)
      //     redraw()
      //   }
      // })

      canvas.addEventListener('touchmove', function(e) {
        if(paint){
          addClick(e.pageX - this.offsetLeft, e.pageY - this.offsetTop, true)
          redraw()
        }
      })

      canvas.addEventListener('touchend', function(e) {
        paint = false
      })

      canvas.addEventListener('mouseup', function(e) {
        paint = false
      })

      canvas.addEventListener('mouseleave', function(e) {
        paint = false
      })

      function addClick(x, y, dragging) {
        clickX.push(x)
        clickY.push(y)
        clickDrag.push(dragging)
      }

      function redraw(){

        //context.clearRect(0, 0, context.canvas.width, context.canvas.height); // Clears the canvas
        
        context.strokeStyle = "#db2000"
        context.lineJoin = "round"
        context.lineWidth = 1
            
        for(var i=0; i < clickX.length; i++) {    
          context.beginPath()
          if(clickDrag[i] && i){
            context.moveTo(clickX[i-1], clickY[i-1])
           } else {
             context.moveTo(clickX[i]-1, clickY[i])
           }
           context.lineTo(clickX[i], clickY[i])
           context.closePath()
           context.stroke()
        }
      }

    }, 
  }

}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.World3D
  position absolute 
  top 0 
  left 0
  width 100vw
  height 100vh
  color black

  &__txt
    position absolute
    top 0
    right 0
    border 1px solid red
    padding 0 12px
    color red

#source-canvas
  position absolute
  top 0px
  left 0px
  width 128px
  height 128px
  border 1px solid white

</style>















